const legalPages = {
  cookiePolicy: {
    href: 'https://www.blyth.cz/stranky/zasady-pouzivani-souboru-cookies',
    name: 'Zásady používání souboru cookies',
  },
  privacyPolicy: {
    href: 'https://www.blyth.cz/stranky/zasady-ochrany-osobnich-udaju',
    name: 'Zásady ochrany osobních údajů',
  },
} as const;

export default legalPages;
